import { render, staticRenderFns } from "./inspection-details.vue?vue&type=template&id=1f2ee0ad&"
import script from "./inspection-details.vue?vue&type=script&lang=js&"
export * from "./inspection-details.vue?vue&type=script&lang=js&"
import style0 from "./inspection-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "inspection-details.vue"
export default component.exports